import en from "./en"
import fr from "./fr"
import es from "./es"

export default { en, fr, es }
